<template>
  <button
    type="button"
    class="m-icon-btn"
    :class="{ 'is-active': active }"
    :aria-label="label"
    :title="label"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <i :class="['fas', 'fa-' + icon, { 'fa-spin': spin }]" aria-hidden="true"></i>
    <span v-if="badge" class="m-icon-btn__badge">{{ badge }}</span>
  </button>
</template>

<script>
/** Botón de solo ícono, 44px de área de toque (Font Awesome, el set del sistema). */
export default {
  name: "MobileIconButton",
  props: {
    icon: { type: String, required: true },
    label: { type: String, required: true },
    active: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    spin: { type: Boolean, default: false },
    badge: { type: [String, Number], default: "" },
  },
};
</script>

<style scoped>
.m-icon-btn {
  position: relative;
  width: 2.75rem;
  height: 2.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--m-text);
  font-size: 1.05rem;
}
.m-icon-btn:active,
.m-icon-btn.is-active {
  background: rgba(var(--bs-primary-rgb), 0.12);
  color: var(--bs-primary);
}
.m-icon-btn:disabled {
  opacity: 0.45;
}
.m-icon-btn__badge {
  position: absolute;
  top: 0.35rem;
  right: 0.3rem;
  min-width: 1.05rem;
  height: 1.05rem;
  padding: 0 0.25rem;
  border-radius: 999px;
  background: var(--bs-primary);
  color: var(--bs-white);
  font-size: 0.65rem;
  line-height: 1.05rem;
  font-weight: 600;
}
</style>
